import React from 'react';
import ReactDOM from 'react-dom';
import { MsalProvider } from '@azure/msal-react';
// auth
import { getMsalInstance } from 'src/auth/msalConfig';
import { LOGOUT_BROADCAST_KEY } from 'src/constants';
// containers
import { AuthenticationContainer } from 'src/app/containers';
import { PageSkeleton } from 'src/components';
// progressive Web app
import * as serviceWorker from './serviceWorker';
// app global styles
import './styles/styles.scss';

const container = document.getElementById('root');
const msalInstance = getMsalInstance();

// When another tab logs out, clear this tab's MSAL cache and reload so we don't stay "logged in"
window.addEventListener('storage', (event: StorageEvent) => {
  if (event.key !== LOGOUT_BROADCAST_KEY || !event.newValue) { return; }
  void msalInstance.clearCache().then(() => {
    localStorage.removeItem(LOGOUT_BROADCAST_KEY);
    window.location.reload();
  });
});

const renderApp = ({ authFailed }: { authFailed?: boolean } = {}) => {
  ReactDOM.render(
    <MsalProvider instance={msalInstance}>
      <AuthenticationContainer authFailed={authFailed} />
    </MsalProvider>,
    container
  );
};

// MSAL must be initialized, then handle redirect callback (return from B2C login) before first render
void msalInstance
  .initialize()
  .then(() => msalInstance.handleRedirectPromise())
  .then(() => {
    renderApp();
  })
  .catch((err: unknown) => {
    // B2C returned an error (e.g. server_error, user unauthorized); still render so StartScreen can show it
    console.error('Auth redirect error', err);
    renderApp({ authFailed: true });
  });

// Show loading while MSAL initializes (avoids blank screen)
if (container) {
  ReactDOM.render(<PageSkeleton />, container);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
